import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { Feeder33Service } from 'shared-lib';
import { ToastrService } from 'ngx-toastr';
import { F33Crud, F33CrudCreate } from '../../../models/f33.model';
import { TransmissionStation } from 'shared-lib';
import { Region } from 'shared-lib';
import { TransmissionStationService } from 'shared-lib';
import { RegionService } from 'shared-lib';
import { DropdownItem } from '../../../models/dropdown.model';
import { UtilitySharedService } from '../../../shared/_services/utility-shared.service';

@Component({
  selector: 'app-crud-f33',
  templateUrl: './crud-f33.component.html',
  styleUrl: './crud-f33.component.scss',
  standalone: false
})
export class CrudF33Component implements OnInit, OnChanges {
  @Input() downloadClicked: boolean = false;
  @Input() reloadTableInput: boolean = false;

  count: number = 0;
  currentPage: number = 1;
  utilityId: number = 1;
  pageSize: number = 10;
  feeders33: F33Crud[] = [];
  searchText: string = "";
  selectedF33: F33Crud = new F33Crud();
  transmissionStations: TransmissionStation[] = [];
  isEditMode: boolean = false;

  updatedName: string = '';
  updatedNumber: string = '';
  updatedTsId: number | null = null;
  updatedRegionIds: number[] = [];
  resetDropdownSearch: boolean = false;

  f33ToSave: F33CrudCreate = new F33CrudCreate();

  regions: Region[] = [];

  @ViewChild('filterTemplate', { static: true })
  filterTemplate!: TemplateRef<any>;

  @Output() filterTemplateReady = new EventEmitter<TemplateRef<any>>();
  selectedRegionIds: number[];

  @Input() set refreshTrigger(_: number) {
    this.filterTemplateReady.emit(this.filterTemplate);
  }

  @ViewChild('closeEditModal') closeEditModal: ElementRef;

  constructor(
    private feeder33Service: Feeder33Service,
    private regionService: RegionService,
    private tsService: TransmissionStationService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private utilitySharedService: UtilitySharedService
  ) {
    this.utilityId = Number(this.utilitySharedService.getUtilityId());
  }

  ngOnChanges(changes: SimpleChanges): void {  
    if (changes['downloadClicked']) {
      const val = changes['downloadClicked'].currentValue;
      if (val) 
        this.download();    
    } else if (changes['reloadTableInput']) {
      setTimeout(() => {
        this.reloadTable(1);
      }, 500);
    }
  }

  ngOnInit(): void {
    this.filterTemplateReady.emit(this.filterTemplate);
    this.reloadTable(1);
    this.getAllTss();
    this.getRegions();
  }

  onTransmissionStationIdChange(selectedId: number | null) {
    this.updatedTsId = selectedId;
  }

  openAddModal() {
    this.isEditMode = false;
    this.selectedF33 = new F33Crud();
    this.updatedName = '';
    this.updatedNumber = '';
    this.updatedTsId = null;
    this.updatedRegionIds = [];
    this.regions = this.regions.map(region => ({ ...region, checked: false }));
  }

  openEditModal() {
    this.isEditMode = true;
    this.fillInputFields();
  }

  onPageChange(newPage: number) {
    this.currentPage = newPage;
    this.reloadTable(newPage);
  }

  private getAllFeeders(dataIn: any) {
    this.feeder33Service.getAll(dataIn).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.feeders33 = responseData.data.data;
          this.feeders33.forEach((x) => {
            x.currentRegions = x.regions?.map((y) => y.name).join(', ');
          });
          this.count = responseData.data.count;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
  }

  getFilterObject() {
    const obj = {
      searchValue: this.searchText
    };
    return obj;
  }

  selectF33(item: F33Crud) {
    this.selectedF33 = item;
    this.openEditModal();
  }

  onDeleteF33(item: F33Crud){
    this.selectedF33 = item;
    this.isEditMode = false;
  }

  private fillInputFields() {
    this.updatedName = this.selectedF33.name;
    this.updatedNumber = this.selectedF33.number;
    this.updatedTsId = this.selectedF33.transmissionStationId;
    this.updatedRegionIds = this.selectedF33.regions.map(region => region.id);
    this.regions = this.regions.map(region => ({
      ...region,
      checked: this.updatedRegionIds.includes(region.id)
    }));
  }

  deleteF33() {
    this.feeder33Service.delete(this.selectedF33.id).subscribe({
      next: (response: any) => {
        if (response.body.status === 200 || response.body.status === 'OK') {
          this.onPageChange(1);
          this.toastr.success(response.body.message);
        } else {
          this.toastr.error(response.body.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
  }

  reloadTable(page: number | null) {
    if (page) this.currentPage = page;
    let obj = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      filterParams: this.getFilterObject(),
      utilityId: this.utilityId
    };
    this.getAllFeeders(obj);
  }

  private mapFeeder() {
    this.f33ToSave.id = this.isEditMode ? this.selectedF33.id : 0;
    this.f33ToSave.utilityId = this.utilityId;
    this.f33ToSave.name = this.updatedName;
    this.f33ToSave.number = this.updatedNumber;
    this.f33ToSave.regionIds = this.updatedRegionIds;
    this.f33ToSave.transmissionStationId = this.updatedTsId !== null ? +this.updatedTsId : 0;
  }

  download() {
    const dataIn = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      filterParams: this.getFilterObject(),
      utilityId: this.utilityId,
    };

    this.feeder33Service.downloadFile(dataIn).subscribe({
      next: (response) => {
        window.location.href = response.data;
      },
      error: (_) => {
        this.toastr.error('An error occurred.');
        this.reloadTable(1);
      }
    });
  }

  save() {
    this.mapFeeder();
    if (this.f33ToSave.name === '') {
      this.toastr.warning("Name can't be empty!");
    } else if (this.f33ToSave.number === '') {
      this.toastr.warning("Number can't be empty!");
    } else if (this.f33ToSave.regionIds.length === 0) {
      this.toastr.warning("Please choose regions!");
    } else if (this.f33ToSave.transmissionStationId === 0) {
      this.toastr.warning("Please choose Transmission Station!");
    } else {
      this.feeder33Service.save(this.f33ToSave).subscribe({
        next: (response: any) => {
          if (response.body.status === 200 || response.body.status === 'OK') {
            this.toastr.success(response.body.message);
            setTimeout(() => {        
              this.reloadTable(1);
              this.closeEditModal?.nativeElement?.click();
            }, 500);
          } else {
            this.toastr.error(response.body.message);
          }
        },
        error: (_) => this.toastr.error('Error occurred'),
      });
    }
  }

  getAllTss() {
    this.tsService.getAllForSelect(this.utilityId).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.transmissionStations = responseData.data;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
  }

  getRegions() {
    this.regionService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.regions = responseData.data.map((region: Region) => ({
            ...region,
            isExpanded: false,
            checked: false
          }));
        } else if (response?.status === 204) {
          this.regions = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
  }

  onRegionsSelected(itemList: any) {
    const selectedRegionNames = itemList;
    this.updatedRegionIds = this.regions.filter(region => selectedRegionNames.includes(region.name)).map(region => region.id);
  }

  onSearch() {
    this.reloadTable(1);
  }
}
